import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./VersionInfoNote.module.scss";
import crossIcon from "../../assets/cross.svg";
import ChangeLog from "../ChangeLog/ChangeLog";

const uriString = "versionNotice";

const VersionInfoNote: React.FC = () => {
  function showReleaseNotificationData(location: string): boolean {
    const versionData = new URLSearchParams(location).get(uriString);
    if (versionData != null) {
      return true;
    } else {
      return false;
    }
  }

  const [showModalWindow, setShowModalWindow] = React.useState(
    showReleaseNotificationData(useLocation().search)
  );

  const location = useLocation().search;
  const versionData = new URLSearchParams(location).get(uriString);
  let redirectURI = location.replaceAll("versionNotice=" + versionData, "");
  while (redirectURI.endsWith("&") || redirectURI.endsWith("?")) {
    redirectURI = redirectURI.slice(0, -1);
  }

  function HideModal() {
    setShowModalWindow(false);
  }

  if (versionData != null && showModalWindow == false) {
    setShowModalWindow(true);
  }

  if (showModalWindow == true) {
    return (
      <div id="showVersionData" className={styles.modal}>
        <div className={styles.modalcontent}>
          <span className={styles.close}>
            <div className={styles.PopupExitButton}>
              <Link to={redirectURI}>
                <img alt="Cross" src={crossIcon} onClick={HideModal} />
              </Link>
            </div>
          </span>
          <div className={styles.notesHeaderDiv}>
            <h1>Release notes</h1>
          </div>
          <div className={styles.PopupNotesMainWindow}>
            <ChangeLog></ChangeLog>
          </div>
          <div className={styles.PopupNotesFooter}>
            <Link to={redirectURI}>
              <button className={styles.PopupExitBottomButton} onClick={HideModal}>
                CLOSE
              </button>
            </Link>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default VersionInfoNote;
